import { UploadStatus } from "lib/types/UploadStatus";

export function getUploadStatusLabel(value: UploadStatus) {
  switch (value) {
    case UploadStatus.preparing:
      return "Preparing";
    case UploadStatus.queued:
      return "Queued";
    case UploadStatus.uploading:
      return "Uploading";
    case UploadStatus.paused:
      return "Paused";
    case UploadStatus.error:
      return "Upload Failed";
    case UploadStatus.complete:
      return "Awaiting Processing";
  }
  return null;
}
